// Component for group of radios.
import * as React from "react";
import { useTranslation } from "react-i18next";
import { TierContext } from "tiers/context";
/** Renders a group of radios. */
export const Radio = (props) => {
    const tiers = React.useContext(TierContext);
    const { t } = useTranslation();
    return React.createElement(React.Fragment, null, props.options.map(optionProps => {
        const { value, label, i18nLabel } = optionProps;
        const id = `${props.id}_${value}`;
        const allowSelection = tiers.allow(optionProps) || (props.allowSelectingTierLockedOptions);
        return React.createElement("div", { key: value, className: "custom-control custom-radio" },
            React.createElement("input", { type: "radio", key: `${value}_radio`, id: id, value: value, disabled: !allowSelection, checked: props.value == value, name: props.id, className: "custom-control-input", onChange: e => props.onChange(props.value, value) }),
            React.createElement("label", { key: `${value}_label`, htmlFor: id, className: "custom-control-label", onClick: !allowSelection ? () => tiers.popup(id) : () => { } },
                t([i18nLabel !== null && i18nLabel !== void 0 ? i18nLabel : "props." + label, label], label),
                tiers.badge(optionProps, "ml-1")));
    }));
};
